import React, { useEffect, useState } from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import {
  FileEarmarkText,
  CheckCircle,
  ClipboardCheck,
  Type,
  Layers,
  PencilSquare,
} from "react-bootstrap-icons";
import EditClaimHeaderModal from "./EditClaimHeaderModal";
import { useDispatch, useSelector } from "react-redux";
import { handleFillStepData } from "../config/claimSlice";
import {
  GetAllClaimPreAuthAllList,
  GetAllPreauthorizationType,
} from "features/preauthorization/config/preauthorizationApi";
import { processSupportingInfo } from "features/preauthorization/utils";
import { GetInsuranceList } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import SubtleBadge from "components/common/SubtleBadge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ClaimHeaderCard = () => {
  const dispatch = useDispatch();
  const {
    preauthorizationType,
    preauthorizationSubType,
    visitReasons,
    processPriority,
  } = useSelector((state) => state.preauthorization);
  const { viewClaimInfo, stepFormData, claimRequestData, eligibilityData } =
    useSelector((state) => state.claim);
  const { insuranceList } = useSelector((state) => state.eligibilityCheck);
  const { allPermissionType } = useSelector((state) => state.role);
  const claimsSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) =>
      item?.rolemngmttyp_name === "Claim" ||
      item?.rolemngmttyp_name === "Claims"
  );
  const [showEditModal, setShowEditModal] = useState(false);
  const claimRequest = claimRequestData?.entry?.find(
    (item) => item?.resource?.resourceType === "Claim"
  );

  const payloadClaim = viewClaimInfo?.payload_json;

  // Convert sup_info to array safely
  const supInfoArray = payloadClaim?.sup_info
    ? Object.values(payloadClaim.sup_info)
    : [];

  // Find the first non-null / non-undefined vreas
  const payloadVisitReason = supInfoArray.reduce(
    (acc, obj) => acc ?? obj?.vreas ?? null,
    null
  );

  const preuathID = claimRequest?.resource?.insurance?.[0]?.preAuthRef?.[0];

  console.log({ info: claimRequest?.resource });

  const epsoideNo =
    claimRequest?.resource?.extension?.find((item) =>
      item?.url?.includes("extension-episode")
    )?.valueIdentifier?.value || viewClaimInfo?.episode_no;

  const periorityCode = claimRequest?.resource?.priority?.coding?.[0]?.code;

  const vitalDetails = processSupportingInfo(
    claimRequest?.resource?.supportingInfo
  );

  const isPrescription =
    claimRequest?.resource?.use === "predetermination" ||
    payloadClaim?.prescript_submt;

  const coverageEligibility = eligibilityData?.entry?.find(
    (item) => item?.resource?.resourceType === "CoverageEligibilityResponse"
  )?.resource;

  const eligibilityID = coverageEligibility?.request?.identifier?.value;

  const visitReason = vitalDetails["reason-for-visit"];
  const status = viewClaimInfo?.claim_status;

  const isDisabled = [
    "error",
    "ready to submit",
    "rejected",
    "cancelled",
    "in process",
    "validation error",
    "invalid",
  ].includes(status?.toLowerCase());

  console.log({ test: payloadClaim?.process_prior });

  const statusConfig = {
    error: { bg: "#fde6d8", color: "#ac5a2b", icon: "exclamation" },
    Error: { bg: "#fde6d8", color: "#ac5a2b", icon: "exclamation" },
    invalid: { bg: "#fde6d8", color: "#ac5a2b", icon: "exclamation" },
    "validation error": {
      bg: "#fff3cd", // Bootstrap warning background
      color: "#856404", // Bootstrap warning text
      icon: "triangle-exclamation",
    },
    "no response": {
      bg: "#08101b",
      color: "#91979e",
      icon: "circle-exclamation",
    },
    approved: { bg: "#d9f8eb", color: "#00894f", icon: "check" },
    "ready to submit": {
      bg: "#d8f3ff",
      color: "#197aa4",
      icon: "check",
    },
    "in process": {
      bg: "#ffe6cc", // soft orange background
      color: "#cc6600", // deep burnt orange text
      icon: "spinner", // conveys in-progress state
    },
    rejected: { bg: "#fbdbe1", color: "#b82c46", icon: "times" },
    cancelled: { bg: "#ffe0fe", color: "#da23aa", icon: "times" },
    "partially approved": {
      bg: "#C2EEF6",
      color: "#0da9bd",
      icon: "star-half-stroke",
    },
    partial: {
      bg: "#C2EEF6",
      color: "#0da9bd",
      icon: "star-half-stroke",
    },
    pended: { bg: "#d9e7fa", color: "#215cac", icon: "clock" },
    "not-required": {
      bg: "#d8f3ff",
      color: "#197aa4",
      icon: "clock",
    },
    queued: { bg: "#fefad2", color: "#a7970d", icon: "list" },
    adjudication: { bg: "#e8dff7", color: "#6f42c1", icon: "gavel" },
    prepared: { bg: "#e6e8ec", color: "#5d6776", icon: "hammer" },
  };

  useEffect(() => {
    if (preauthorizationType?.length === 0) {
      dispatch(GetAllPreauthorizationType());
    }

    if (insuranceList?.length === 0) {
      dispatch(GetInsuranceList());
    }
  }, []);

  useEffect(() => {
    // Initialize stepFormData with claim details
    dispatch(
      handleFillStepData({
        check: "payer",
        value:
          insuranceList?.find(
            (item) =>
              item?.insurance_company_id === viewClaimInfo?.insurance_company_id
          ) || null,
      })
    );
    dispatch(
      handleFillStepData({
        check: "claim_id",
        value: viewClaimInfo?.claim_id || "",
      })
    );
    dispatch(
      handleFillStepData({
        check: "claim_type",
        value:
          preauthorizationType?.find(
            (item) => item?.claim_types_code === viewClaimInfo?.claim_type
          ) || null,
      })
    );
    dispatch(
      handleFillStepData({
        check: "claim_sub_type",
        value:
          preauthorizationSubType?.find(
            (item) => item?.claimsub_types_name === viewClaimInfo?.claim_subtype
          ) || null,
      })
    );
    dispatch(
      handleFillStepData({
        check: "visit_reason",
        value:
          visitReasons?.find(
            (item) =>
              item?.visitreas_code === visitReason ||
              item?.visitreas_code === payloadVisitReason
          ) || null,
      })
    );
    dispatch(
      handleFillStepData({
        check: "eposide_no",
        value: epsoideNo || "",
      })
    );
    dispatch(
      handleFillStepData({
        check: "online_eligibility_ref_no",
        value: eligibilityID || payloadClaim?.patient_eligbid || "",
      })
    );
    dispatch(
      handleFillStepData({
        check: "prescription",
        value: isPrescription || false,
      })
    );
    dispatch(
      handleFillStepData({
        check: "priority_type",
        value:
          processPriority?.find(
            (item) =>
              item?.prcspri_code === "normal" ||
              item?.prcspri_code === periorityCode
          ) || "",
      })
    );
    dispatch(
      handleFillStepData({
        check: "prescription_ref_no",
        value: claimRequest?.resource?.prescription?.[0]?.display || "",
      })
    );
    dispatch(
      handleFillStepData({
        check: "patient_preauthid",
        value: payloadClaim?.patient_preauthid || preuathID || "",
      })
    );
  }, [
    dispatch,
    insuranceList,
    preauthorizationType,
    preauthorizationSubType,
    visitReasons,
    processPriority,
    viewClaimInfo,
    payloadClaim,
    claimRequest,
  ]);

  useEffect(() => {
    if (visitReasons?.length === 0) {
      dispatch(GetAllClaimPreAuthAllList());
    }
  }, []);

  console.log({ processPriority });

  const value = viewClaimInfo?.claim_status?.toLowerCase();
  const config = statusConfig[value] || {
    bg: "#f8f9fa",
    color: "#000",
    icon: "question",
  };
  const infoItems = [
    {
      label: "Insurance Company",
      value: stepFormData?.payer?.payer_name
        ? stepFormData?.payer?.insurance_direct === 0
          ? `${stepFormData.payer.payer_name} - ${stepFormData.payer.insurance_shname}`
          : stepFormData.payer.payer_name
        : stepFormData?.payer?.insurance_company_name || "",
    },
    {
      label: "Claim Status",
      value: (
        <SubtleBadge
          pill
          style={{
            backgroundColor: config.bg,
            color: config.color,
            border: `1px solid ${config.color}20`,
            width: "90px",
          }}
          className="d-flex flex-center fs-13 p-1"
        >
          <FontAwesomeIcon
            icon={config.icon}
            transform="shrink-2"
            className="ms-1 me-1"
          />
          {value ? value.charAt(0).toUpperCase() + value.slice(1) : "-"}
        </SubtleBadge>
      ),
    },
    {
      label: "Episode No.",
      value: stepFormData?.eposide_no || "",
    },
    {
      label: "Type",
      value: stepFormData?.claim_type?.claim_types_name || "",
    },
    {
      label: "Sub Type",
      value: stepFormData?.claim_sub_type?.claimsub_types_name || "",
    },
    {
      label: "Visit Reason",
      value: stepFormData?.visit_reason?.visitreas_name || "",
    },
    {
      label: "Prescription Ref No",
      value: stepFormData?.prescription_ref_no || "",
    },
    {
      label: "Priority",
      value: stepFormData?.priority_type?.prcspri_name || "",
    },
  ];

  return (
    <>
      <div>
        <Card.Header className="d-flex badge-subtle-info justify-content-between border-info align-items-center border-bottom">
          <strong className="text-info fw-bold fs-12">
            <ClipboardCheck className="me-2" />
            Claim Header Details
          </strong>
          {isDisabled && Number(claimsSetting?.submit) === 1 && (
            <PencilSquare
              size={12}
              className="text-info"
              onClick={() => setShowEditModal(true)}
              role="button"
            />
          )}
        </Card.Header>

        <Card.Body className="p-2">
          <Row>
            {infoItems.map((item, index) => (
              <Col
                md={6}
                xs={12}
                key={index}
                className="mb-1 d-flex flex-column"
              >
                <div className="text-800 fw-bold fs-12 flex-wrap">
                  {item.label}:
                </div>
                <div className="fw-semibold text-600 fs-12">{item.value}</div>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </div>
      <EditClaimHeaderModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
      />
    </>
  );
};

export default ClaimHeaderCard;
